import { useQuery } from '@tanstack/react-query';
import { branchesApi } from '../api/branches.api';
import { usePermissions } from '@/hooks/usePermissions';

export const BRANCHES_KEY = ['branches'] as const;
export const CURRENT_BRANCH_KEY = ['branches', 'current'] as const;

/** Todos los locales (solo admin; para el cajero devuelve lista vacía sin pedir nada). */
export function useBranches() {
    const { isAdmin } = usePermissions();
    return useQuery({
        queryKey: BRANCHES_KEY,
        queryFn: branchesApi.getAll,
        enabled: isAdmin,
        staleTime: 60_000,
    });
}

export function useActiveBranches() {
    const query = useBranches();
    return { ...query, data: (query.data ?? []).filter((b) => b.isActive) };
}

/** Local donde está trabajando el usuario. */
export function useCurrentBranch() {
    return useQuery({
        queryKey: CURRENT_BRANCH_KEY,
        queryFn: branchesApi.getCurrent,
        staleTime: 60_000,
    });
}
